import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { Employeur } from 'src/app/shared/models/employeur';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';

@Injectable({
	providedIn: 'root'
})
export class EmployeurService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllEmployeurs(): Observable<Employeur[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeurUrl}/all`,
			'getAllEmployeurs',
		);
	}

	/**
	 * Renvoi la liste de tout les employeurs avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de employeur
	 */
	getEmployeursMinimal(): Observable<Employeur[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeurUrl}`,
			'getEmployeurs',
			httpOptions
		);
	}

	/**
	 * Renvoi la liste de tout les employeurs avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de employeur
	 */
	getEmployeursPageable(
		page: number,
		size: number,
		search: string,
		skills: string
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}
		if (skills) {
			queryParams = queryParams.append('skill', skills);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeurUrl}/page`,
			'getEmployeurs',
			httpOptions
		);
	}

	/**
	 * Renvoie un employeur en fonction de l'id transmie
	 * @param id id de l'utilisateur
	 * @returns employeur
	 */
	getEmployeurById(id: number): Observable<Employeur> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeurUrl}/get/${id}`,
			'getEmployeurById'
		);
	}

	importEmployeurs(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'employeurs.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeurUrl}/import`,
			`importEmployeurs`,
			formData
		);
	}

	/**
	 * Met à jour un employeur
	 * @param employeur
	 * @returns
	 */
	updateEmployeur(employeur: Employeur): Observable<string> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.employeurUrl}/update/${employeur.id}`,
			`updateEmployeur`,
			employeur
		);
	}

	/**
	 * Sauvegarde un employeur
	 * @param employeur
	 * @returns
	 */
	addEmployeur(employeur: Employeur): Observable<number> {
		console.log(employeur);
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeurUrl}/add`,
			`addEmployeur`,
			employeur
		);
	}

	/**
	 * Supprime un employeur
	 * @param employeurId
	 * @returns
	 */
	deleteEmployeur(employeurId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.employeurUrl}/delete/${employeurId}`,
			`deleteEmployeur`
		);
	}
}
